<app-toast-message #toast toastKey="permission-groups"></app-toast-message>
<div class="permission-setting-box">
  <form [formGroup]="userForm" autocomplete="off" class="flex-row gap-5">
    <!-- Changed formGroup name -->
    <div class="flex gap-4">
      <div class="form-group w-3">
        <label for="user">Selected User <span class="required">*</span></label>
        <p-dropdown
          [options]="users"
          optionLabel="name"
          [filter]="true"
          formControlName="user"
          placeholder="Select user"
          [appendTo]="'body'"
          [lazy]="true"
          [virtualScroll]="true"
          [virtualScrollItemSize]="40"
          (onFilter)="onFilterUsers($event)"
          [virtualScrollOptions]="options"
          [ngClass]="{
            'ng-invalid ng-dirty':
              formSubmitted && userForm.controls['user'].invalid
          }"
          (onChange)="onUserChange($event)"
        ></p-dropdown>
      </div>
      <div class="form-group w-3">
        <label for="roleType">Role Type <span class="required">*</span></label>
        <input
          id="roleType"
          type="text"
          pInputText
          placeholder="Enter role type"
          formControlName="roleType"
          [ngClass]="{
            'ng-invalid ng-dirty':
              formSubmitted && userForm.controls['roleType'].invalid
          }"
        />
      </div>
      <div class="form-group w-3">
        <label for="responsibleRegion"
          >User Responsible Region <span class="required">*</span></label
        >
        <input
          id="responsibleRegion"
          type="text"
          pInputText
          placeholder="Enter region"
          formControlName="responsibleRegion"
          [ngClass]="{
            'ng-invalid ng-dirty':
              formSubmitted && userForm.controls['responsibleRegion'].invalid
          }"
        />
      </div>
      <div class="form-group w-3">
        <label for="userCountry"
          >User Responsible Country <span class="required">*</span></label
        >
        <input
          id="userCountry"
          type="text"
          pInputText
          placeholder="Enter Country"
          formControlName="userCountry"
          [ngClass]="{
            'ng-invalid ng-dirty':
              formSubmitted && userForm.controls['userCountry'].invalid
          }"
        />
      </div>
    </div>
    <div class="flex gap-4 mt-5">
      <div class="form-group w-3">
        <label for="issuedDate"
          >Issued Date<span class="required">*</span></label
        >
        <p-calendar
          formControlName="issuedDate"
          dateFormat="mm/dd/yy"
          inputId="issuedDate"
          placeholder="Enter Issued Date"
          [showIcon]="true"
          styleClass="w-full"
          [ngClass]="{
            'ng-invalid ng-dirty':
              formSubmitted && userForm.controls['issuedDate'].invalid
          }"
        ></p-calendar>
      </div>
      <div class="form-group w-3">
        <label for="dueDate">Due Date <span class="required">*</span></label>
        <p-calendar
          formControlName="dueDate"
          dateFormat="mm/dd/yy"
          inputId="dueDate"
          placeholder="Enter Due Date"
          [showIcon]="true"
          styleClass="w-full"
          [ngClass]="{
            'ng-invalid ng-dirty':
              formSubmitted && userForm.controls['dueDate'].invalid
          }"
        ></p-calendar>
      </div>
      <div class="form-group w-5" pTooltip="select user">
        <label for="permission"
          >Selected Permissions <span class="required">*</span></label
        >
        <div class="dropdown-container">
          <div class="dropdown-input" (click)="toggleDropdown()">
            <ng-container
              *ngIf="selectedPermission.length > 0; else placeholder"
            >
              <span
                *ngFor="let permission of selectedPermission.slice(0, 2)"
                class="tag"
                [pTooltip]="permission.name"
              >
                {{
                  permission.name.length > 15
                    ? (permission.name | slice : 0 : 15) + ".."
                    : permission.name
                }}
                <span
                  class="remove-tag"
                  (click)="
                    removeSelection(permission); $event.stopPropagation()
                  "
                  >×</span
                >
              </span>
              <span
                *ngIf="selectedPermission.length > 2"
                class="extra-count"
                [pTooltip]="getSliceValue()"
              >
                +{{ selectedPermission.length - 2 }} more
              </span>
            </ng-container>
            <ng-template #placeholder>
              <span class="placeholder">Select Permissions</span>
            </ng-template>
            <span class="arrow">
              <i class="pi pi-chevron-up icon" *ngIf="dropdownOpen"></i>
              <i class="pi pi-chevron-down icon" *ngIf="!dropdownOpen"></i>
            </span>
          </div>
          <ng-container *ngIf="availablePermissions.length > 0">
            <div class="dropdown-list" *ngIf="dropdownOpen">
              <div
                *ngFor="let permission of availablePermissions"
                class="dropdown-item"
              >
                <input
                  type="checkbox"
                  [checked]="permission.isSelected"
                  [disabled]="permission.isDisabled"
                  [ngClass]="{ 'yellow-checkbox': permission.isSelected }"
                  (change)="toggleSelection(permission)"
                />
                <label>{{ permission.name }}</label>
              </div>
            </div>
          </ng-container>
        </div>
      </div>
      <div class="form-group w-0"></div>
    </div>
    <div class="mt-5 flex justify-content-end">
      <div class="filter-action-row">
        <button
          pButton
          type="button"
          [disabled]="userForm.invalid || !isPermissionChanged()"
          label="Save"
          class=""
          (click)="save()"
        ></button>
      </div>
    </div>
  </form>
</div>

<app-success
  [(visible)]="showCustomerDetailsSuccessDialog"
  [dialogTitle]="customerDetailsSuccessDialogTitle"
  [successMessage]="customerDetailsSuccessMessage"
  (onClose)="onCustomerDetailsSuccessDialogClose()"
></app-success>
